import { InjectionToken } from '@angular/core';

export const APP_BACK_NAVIGATION_ROOT = new InjectionToken<string>(
  'APP_BACK_NAVIGATION_ROOT'
);
